<script lang="ts" generics="T extends string">
  import type { Component } from 'svelte';

  interface Item {
    value: T;
    label: string;
    icon?: Component<{ size?: number; 'aria-hidden'?: boolean | 'true' }>;
  }

  interface Props {
    label: string;
    items: Item[];
    value: T;
    onChange: (value: T) => void;
    segmented?: boolean;
    panelId?: string;
    /** manual: the arrow keys only move focus, and Enter or Space selects. Use it when selecting a tab throws away work. */
    activation?: 'automatic' | 'manual';
  }

  let { label, items, value, onChange, segmented = false, panelId, activation = 'automatic' }: Props = $props();

  let buttons: HTMLButtonElement[] = $state([]);

  function onKeydown(event: KeyboardEvent, index: number) {
    const last = items.length - 1;
    let next: number | null = null;
    if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
    if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = last;
    if (next === null) return;
    event.preventDefault();
    buttons[next]?.focus();
    if (activation === 'automatic') onChange(items[next].value);
  }
</script>

<div class={segmented ? 'stat-segmented' : 'stat-tabs stat-tabs--inline'} role="tablist" aria-label={label}>
  {#each items as item, index (item.value)}
    {@const selected = item.value === value}
    <button
      bind:this={buttons[index]}
      type="button"
      role="tab"
      class={segmented ? 'stat-segmented__item' : 'stat-tab'}
      aria-controls={panelId}
      aria-selected={selected}
      tabindex={selected ? 0 : -1}
      onclick={() => onChange(item.value)}
      onkeydown={(event) => onKeydown(event, index)}
    >
      {#if item.icon}<item.icon size={18} aria-hidden="true" />{/if}
      <span>{item.label}</span>
    </button>
  {/each}
</div>
